import { render } from "./IconValley.vue?vue&type=template&id=6f979798"
import script from "./IconValley.vue?vue&type=script&lang=js"
export * from "./IconValley.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__